import { echo } from 'App';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import { addEvent } from 'redux/webSocket/slice';

export default function useWebSocketAlert() {
  const dispatch = useDispatch();
  const location = useLocation();
  const role = localStorage.getItem('role');

  useEffect(() => {
    if (location.pathname === '/login' || !localStorage.getItem('token')) {
      return;
    }

    let channel: any = null;

    const createdAlert = (data: any) => {
      if (role === 'worksupport') {
        return;
      }
      dispatch(addEvent(data.notification));
    };

    const expiredAlert = (data: any) => {
      if (role === 'worksupport') {
        return;
      }
      const removePayload = {
        id: data.notification?.id,
        removed: true,
      } as { id: number; removed: true };

      dispatch(addEvent(removePayload));
    };

    try {
      channel = echo.private('common');
      channel.listen('.notification.created', createdAlert);
      channel.listen('.notification.expired', expiredAlert);
    } catch (error) {
      console.error('Failed to setup WebSocket listener:', error);
    }

    return () => {
      if (channel) {
        try {
          echo.leave('common');
        } catch (error) {
          console.error('Failed to cleanup WebSocket listener:', error);
        }
      }
    };
  }, [dispatch]);
}
